import { useEffect, useState } from "react";
import { AtSign, Check } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fmtDateTime } from "../lib/api";
import { Button } from "./ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";

export function MyMentionsCard({ onOpen }) {
  const [items, setItems] = useState([]);
  const load = () => api.get("/chat/mentions").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 45000); return () => clearInterval(t); }, []);
  const done = async (id) => {
    try { await api.post(`/chat/mentions/${id}/done`); setItems(items.filter((i) => i.id !== id)); } catch (e) { toast.error(errMsg(e)); }
  };
  if (!items.length) return null;
  return (
    <Card className="bg-card border-amber-500/40 shadow-sm" data-testid="my-mentions-card">
      <CardHeader className="pb-2">
        <CardTitle className="text-base font-heading flex items-center gap-2"><AtSign className="w-4 h-4 text-amber-400" /> Tag untuk Saya <span className="ml-1 min-w-5 h-5 px-1.5 rounded-full bg-amber-500 text-black text-[11px] font-bold flex items-center justify-center" data-testid="my-mentions-count">{items.length}</span></CardTitle>
        <p className="text-xs text-muted-foreground">Chat yang menyebut Anda dan belum Anda balas. Hilang otomatis setelah Anda membalas di chat tersebut.</p>
      </CardHeader>
      <CardContent className="p-0">
        <div className="divide-y divide-border">
          {items.map((m) => (
            <div key={m.id} className="flex items-center gap-2 px-4 py-2.5 hover:bg-accent/50 transition-colors" data-testid={`my-mention-${m.id}`}>
              <button type="button" onClick={() => onOpen(m.channel)} className="flex-1 min-w-0 text-left" data-testid={`my-mention-open-${m.id}`}>
                <div className="text-sm font-medium truncate"><span className="text-amber-400">{m.from}</span> → chat <span className="font-mono text-emerald-500">{m.channel_label}</span></div>
                <div className="text-xs text-muted-foreground truncate">{m.text}</div>
                <div className="text-[10px] text-muted-foreground font-mono">{fmtDateTime(m.created_at)}</div>
              </button>
              <Button size="sm" variant="outline" className="h-7 text-xs" onClick={() => done(m.id)} title="Tandai sudah ditangani" data-testid={`my-mention-done-${m.id}`}><Check className="w-3.5 h-3.5 mr-1" /> Selesai</Button>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
